<template lang="">
  <div v-if="loggedIn">
    <!-- Error display -->
    <div
      v-if="errorContent"
      class="alert alert-danger"
    >
      {{ errorContent }}
    </div>

    <!-- Loading state -->
    <div
      v-if="loading"
      class="d-flex justify-content-center align-items-center"
      style="min-height: 400px;"
    >
      <b-spinner class="align-middle mr-2" />
      <strong>Lade Kundendaten...</strong>
    </div>

    <!-- Content -->
    <template v-else-if="customerEntry">
      <!-- First Row -->
      <b-row class="match-height">
        <b-col
          xl="8"
          lg="12"
          md="12"
          sm="12"
        >
          <b-row class="match-height">
            <b-col
              xl="6"
              lg="6"
              md="12"
              sm="12"
            >
              <customer-view-info-card-part-one
                :customer-entry="customerEntry"
              />
            </b-col>
            <b-col
              xl="6"
              lg="6"
              md="12"
              sm="12"
            >
              <customer-view-info-card-part-two
                :customer-entry="customerEntry"
              />
            </b-col>

            <b-col
              xl="12"
              lg="12"
              md="12"
              sm="12"
            >
              <customer-view-plan-card
                v-if="ordersFromCustomer && ordersFromCustomer.length > 0"
                :orders-from-customer="ordersFromCustomer"
                :customer-id="Number(id)"
              />
            </b-col>
          </b-row>
        </b-col>
        <b-col
          xl="4"
          lg="12"
          md="12"
          sm="12"
        >
          <customer-timeline
            :id="id"
            :customer-activities="customerEntry"
          />
        </b-col>
      </b-row>

      <b-row class="match-height">
        <b-col
          cols="12"
          xl="12"
          lg="12"
          md="12"
        >
          <customer-orders
            v-if="ordersFromCustomer && ordersFromCustomer.length > 0"
            :orders="ordersFromCustomer"
          />
        </b-col>
      </b-row>
      <b-row class="match-height">
        <b-col
          cols="12"
          xl="12"
          lg="12"
          md="12"
        >
          <customer-offers
            :offers="offersFromCustomer || []"
          />
        </b-col>
      </b-row>
      <b-row class="match-height">
        <b-col
          xl="12"
          lg="12"
          md="12"
          sm="12"
        >
          <customer-attachements
            :customer-attachments="customerEntry.attachments"
            :customer-i-d="customerEntry.id"
          />
        </b-col>
      </b-row>
      <!-- <b-row>
        <b-col cols="12" xl="12" lg="12" md="12">
          <customer-timeline />
        </b-col>
      </b-row> -->
    </template>

    <!-- Customer not found -->
    <div
      v-else
      class="d-flex justify-content-center align-items-center"
      style="min-height: 400px;"
    >
      <div class="text-center">
        <h4>Kunde nicht gefunden</h4>
        <p>Der angeforderte Kunde konnte nicht gefunden werden.</p>
        <b-button
          variant="primary"
          @click="$router.push('/customers-list')"
        >
          Zurück zur Kundenliste
        </b-button>
      </div>
    </div>
  </div>
  <div v-else>
    Forbidden
  </div>
</template>

<script>
import { BRow, BCol, BSpinner, BButton } from 'bootstrap-vue'
import CustomerViewInfoCardPartOne from './CustomerViewInfoCardPartOne.vue'
import CustomerViewInfoCardPartTwo from './CustomerViewInfoCardPartTwo.vue'
import CustomerViewInfoCardPartThree from './CustomerViewInfoCardPartThree.vue'
import CustomerViewPlanCard from './CustomerViewPlanCard.vue'
import CustomerOrders from './CustomerOrders.vue'
import CustomerOffers from './CustomerOffers.vue'
import CustomerTimeline from './CustomerTimeline.vue'
import CustomerAttachements from './CustomerAttachements.vue'

export default {
  components: {
    BRow,
    BCol,
    BSpinner,
    BButton,
    // Local Components
    CustomerViewInfoCardPartOne,
    CustomerViewInfoCardPartTwo,
    CustomerViewInfoCardPartThree,
    CustomerViewPlanCard,
    CustomerOrders,
    CustomerOffers,
    CustomerTimeline,
    CustomerAttachements,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      errorContent: '',
    }
  },
  computed: {
    loggedIn() {
      return this.$store.state.authentication.status.loggedIn
    },
    customerEntry() {
      const customer = this.$store.getters.customerById(Number(this.id))
      return customer || null
    },
    ordersFromCustomer() {
      const order = this.$store.getters.orderByCustomerId(Number(this.id))
      return order
    },
    offersFromCustomer() {
      return this.$store.getters.offersByCustomerId(Number(this.id))
    },
  },
  async mounted() {
    await this.loadCustomerData()
  },
  methods: {
    async loadCustomerData() {
      this.loading = true
      this.errorContent = ''
      
      try {
        // Ensure customer data is loaded
        if (!this.$store.getters.customerEntries?.length) {
          await this.$store.dispatch('getCustomerEntries')
        }
        
        // Ensure order data is loaded
        if (!this.$store.getters.orderEntries?.length) {
          await this.$store.dispatch('getOrderEntries')
        }
        
        // Ensure order item data is loaded
        if (!this.$store.getters.orderItemsEntries?.length) {
          await this.$store.dispatch('getOrderItemsEntries')
        }

        // Ensure offer data is loaded
        if (!this.$store.getters.offerEntries?.length) {
          await this.$store.dispatch('getOfferEntries')
        }
      } catch (error) {
        console.error('Error loading customer data:', error)
        this.errorContent = 'Fehler beim Laden der Kundendaten. Bitte versuchen Sie es erneut.'
      } finally {
        this.loading = false
      }
    },
    
    sortedAttachments() {
      if (!this.customerEntry?.attachments) return []
      return this.customerEntry.attachments.sort(
        (a, b) => (a.created_at < b.created_at ? 1 : -1)
      )
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-sweetalert.scss';
</style>
